module.exports = __webpack_public_path__ + "static/media/boy_river_waves.16d446c8.png";